module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"order":"Order | Orders"}}')
  delete Component.options._Ctor
}
